"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterGroup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string
} : {};
var defaultProps = {
  component: 'div'
};

var FooterGroup =
/*#__PURE__*/
_react["default"].forwardRef(function (props, ref) {
  var component = props.component,
      className = props.className,
      FooterProps = _objectWithoutProperties(props, ["component", "className"]);

  return (0, _core.jsx)(_components.FooterGroup, (0, _extends2["default"])({
    as: component,
    "data-testid": props['data-testid'],
    ref: ref,
    className: className
  }, FooterProps));
});

exports.FooterGroup = FooterGroup;
process.env.NODE_ENV !== "production" ? FooterGroup.propTypes = propTypes : void 0;
FooterGroup.defaultProps = defaultProps;